module.exports = {
    ALLOCATIONS: {
        UNALLOCATED: '',
        CONTROL: '1',
        TEST_B: '2',
        TEST_C: '3'
    },
    EXPERIMENTS: {
        CAT_LISTING_CATEGORY_PAGE_ORDER_SIDEMENU: 2397,
        CAT_LISTINGS_GUIDED_SEARCH_NAV_TEST: 2451,
        CAT_LISTINGS_ASP_RECOMMENDATION_PACKAGE: 2766,
        CAT_LISTINGS_SC_FILTER_TILES: 2874,
        CAT_LISTINGS_SEARCH_FILTER_TILES: 2895,
        CAT_LISTINGS_NSC_ICONS_MOBILE_WEB: 2893,
        LIONS_PROMOTE_MT_CTA: 2854,
        VIDEO_SUBTITLE: 2861,
        SELLER_DISCOUNTS_TEST: 2878,
        SELLER_DISCOUNTS_TEST_LOGO_DESIGN: 2879,
        SPIDERS_BANNER_MPI_SEARCH: 2824,
        LIONS_SAME_LANGUAGE_SELLER_TOGGLE: 2870
    },
    ROLLOUTS: {
        CAT_SC_NAVIGATION_TILES: 'cat_sc_navigation_tiles',
        CAT_SEARCH_NAVIGATION_TILES: 'cat_search_navigation_tiles_changes',
        CAT_NSC_ICONS_MOBILE_WEB: 'cat_nsc_icons_mobile_web',
        SELLER_DISCOUNTS_TEST: 'seller_discounts_test',
        SELLER_DISCOUNTS_TEST_LOGO_DESIGN: 'seller_discounts_for_logo_design_test',
        SPIDERS_BANNER_MPI_SEARCH: 'spiders_banner_mpi_search',
        LIONS_SAME_LANGUAGE_SELLER_TOGGLE: 'lions_same_language_seller_toggle'
    },
    DEFAULT_NUM_OF_GROUPS: 2,
    DISCOUNTS_TEST: {
        EXCLUDE_COUNTRIES: ['IN', 'PK', 'BD'],
        SUBCATEGORIES: [112, 163, 363, 371],
        LOGO_DESIGN: 49,
        QUERIES: [

            // design for streamers
            'twitch',
            'twitch overlay',
            'twitch emotes',
            'emotes',
            'stream overlay',
            'twitch panels',
            'twitch sub badges',
            'twitch emote',
            'overlay',
            'stream',
            'twitch emotes and sub badges',
            'emote',
            'twitch overlays',
            'twitch overlay animated',
            'sub badges',
            'overlay twitch',
            'stream package',
            'emote twitch',
            'fortnite thumbnail',
            'twitch badges',
            'streaming',
            'animated twitch overlay',
            'twitch package',
            'animated stream overlay',
            'emotes twitch',
            'overlays',
            'twitch stream package',
            'twitch logo design',
            'stream logo',
            'animated overlay',

            // brand style guide
            'brand style guide',
            'brand guidelines',
            'brand book',
            'corporate brand identity',
            'brand guide',
            'brand style guides',
            'style guide',
            'brand guideline',
            'brand package',
            'branding guideline',
            'branding guide',
            'color scheme',
            'brand packaging',
            'branding guidelines',
            'brand color palette',
            'brand guides',
            'logo and brand guide',
            'brand guide style',
            'logo and style guide',
            'style guides',
            'brand guide and logo',
            'design guide',
            'guide design',
            'logo style guide',
            'logo brand guide',
            'color palette for brand',
            'design a guide',
            'branded packaging',
            'branding guides',
            'color palette brand',

            // blogs
            'content writer',
            'article writing',
            'blog',
            'writing',
            'blog writing',
            'content writing',
            'writer',
            'writing blog articles',
            'blog post',
            'seo article writing',
            'write content',
            'blog writer',
            'blog post writer',
            'amazon affiliate articles',
            'seo content writer',
            'buy reviews',
            'rewrite',
            'blogger',
            'article writer',
            'article rewriting',
            'seo blog writing',
            'health and fitness',
            'write article',
            'medical writing',
            'mental health',
            'write',
            'seo friendly article writing',
            'seo content',
            'seo article',
            'medium',

            // cv writing
            'resume',
            'cv',
            'resume writing',
            'professional resume writing',
            'cover letter',
            'cv writing',
            'linkedin profile',
            'professional cv writing',
            'professional resume',
            'resume editing',
            'resume and cover letter',
            'resume writer',
            'professional resume writing service',
            'recommendation letter',
            'cv and cover letter',
            'product manager',
            'resume writing service',
            'create resume',
            'resume review',
            'reference letter',
            'recommendation',
            'it resume',
            'tech resume',
            'linkedin cover',
            'resumes',
            'product management',
            'resume builder',
            'ats cv',
            'cv editing',
            'professional cv writing service'
        ],
        LOGO_QUERIES: [
            'logo',
            'logo design',
            'minimalist logo',
            'twitch logo',
            'business logo',
            'gaming logo',
            'branding',
            'youtube logo',
            'fashion logo',
            'creative logo design',
            'signature logo',
            'free',
            'real estate logo',
            'mascot logo',
            'logos',
            '3d logo',
            'minimalist logo design',
            'cartoon logo',
            'business logo design',
            'design logo',
            'modern logo',
            'unique logo',
            'logo designer',
            'luxury logo',
            'vintage logo',
            'clothing logo',
            'embroidery digitizing',
            'clothing brand logo',
            'logo creation',
            'simple logo design'
        ]
    }
};
